import React, { useContext } from 'react';
import AdContainer from 'src/components/ads';
import { AppContext } from '@prisjakt/ui-app-context';
import { MarketCodes } from 'config/types/market';

const MobileTopAd: React.VFC = () => {
  const { market } = useContext(AppContext);
  const enabledMarkets: MarketCodes[] = ['fi', 'se', 'no'];
  const showMobileAd = enabledMarkets.indexOf(market.code) > -1;
  return (
    <>
      {showMobileAd && (
        <AdContainer
          placement="dubbelpanorama1"
          min={0}
          max={860}
          format="panorama_1"
          spacing={{ top: '10px' }}
        />
      )}
    </>
  );
};

export default MobileTopAd;
